/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to grant a feature bundle to a tenant
 * @export
 * @interface GrantBundleRequest
 */
export interface GrantBundleRequest {
    /**
     * Tenant ID
     * @type {string}
     * @memberof GrantBundleRequest
     */
    tenantId: string;
    /**
     * Bundle ID (e.g. MXDR, ALL_FEATURES)
     * @type {string}
     * @memberof GrantBundleRequest
     */
    bundleId: string;
    /**
     * Source: BUNDLE, ADDON, TRIAL, MANUAL_GRANT, EARLY_ACCESS
     * @type {string}
     * @memberof GrantBundleRequest
     */
    source?: string;
    /**
     * Principal who granted (e.g. email). If omitted, set from session when available.
     * @type {string}
     * @memberof GrantBundleRequest
     */
    grantedBy?: string;
    /**
     * Quantity (seats or units)
     * @type {number}
     * @memberof GrantBundleRequest
     */
    quantity?: number;
    /**
     * Quantity limit (null = unlimited)
     * @type {number}
     * @memberof GrantBundleRequest
     */
    quantityLimit?: number;
    /**
     * Effective from (ISO-8601). Defaults to now.
     * @type {Date}
     * @memberof GrantBundleRequest
     */
    effectiveFrom?: Date;
    /**
     * Effective to (ISO-8601). Null = no expiry.
     * @type {Date}
     * @memberof GrantBundleRequest
     */
    effectiveTo?: Date;
}

/**
 * Check if a given object implements the GrantBundleRequest interface.
 */
export function instanceOfGrantBundleRequest(value: object): value is GrantBundleRequest {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('bundleId' in value) || value['bundleId'] === undefined) return false;
    return true;
}

export function GrantBundleRequestFromJSON(json: any): GrantBundleRequest {
    return GrantBundleRequestFromJSONTyped(json, false);
}

export function GrantBundleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrantBundleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'],
        'bundleId': json['bundleId'],
        'source': json['source'] == null ? undefined : json['source'],
        'grantedBy': json['grantedBy'] == null ? undefined : json['grantedBy'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'quantityLimit': json['quantityLimit'] == null ? undefined : json['quantityLimit'],
        'effectiveFrom': json['effectiveFrom'] == null ? undefined : (new Date(json['effectiveFrom'])),
        'effectiveTo': json['effectiveTo'] == null ? undefined : (new Date(json['effectiveTo'])),
    };
}

export function GrantBundleRequestToJSON(json: any): GrantBundleRequest {
    return GrantBundleRequestToJSONTyped(json, false);
}

export function GrantBundleRequestToJSONTyped(value?: GrantBundleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'bundleId': value['bundleId'],
        'source': value['source'],
        'grantedBy': value['grantedBy'],
        'quantity': value['quantity'],
        'quantityLimit': value['quantityLimit'],
        'effectiveFrom': value['effectiveFrom'] == null ? undefined : ((value['effectiveFrom']).toISOString()),
        'effectiveTo': value['effectiveTo'] == null ? undefined : ((value['effectiveTo']).toISOString()),
    };
}

